const staticPixels = "\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-W6FD9FK0F1&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-L503B350W9&l=dataLayer\"></script>\n<script async src=\"https://www.googletagmanager.com/gtag/js?id=G-TLZFEE5CPR&l=dataLayer\"></script>";
const pixelsCategories = ["STRICTLY_NECESSARY","TARGETING"];

export { staticPixels };
export { pixelsCategories };